<template>
  <div id="app">
    <nav class="navbar nav-grid"> 
      <div class="content nav-item-grid">
        <div class="flex title"> 
          <router-link class="navlink title-button" to="/">BZarco</router-link>
        </div>


        <div class="desktop flex">
          <ul class="flex">
            <li class="">
              <router-link class="navlink" to="/aboutme">About Me</router-link>
            </li>
            <li class="">
              <router-link class="navlink" to="/myprojects">My Projects</router-link>
            </li>
            <li class="">
              <router-link class="navlink contact-button" to="/contactme">Contact Me!</router-link>
            </li>
          </ul>
        </div>

        <div class="mobile flex">
          <div class="burger" v-bind:class="{ cross: isActive } " @click="isActive = !isActive">
              <div class="bar1"></div>
              <div class="bar2"></div>
              <div class="bar3"></div>
          </div>
        </div>

      </div>     
    </nav>
    <transition name="slide-fade">
      <div class="burger-menu" v-if="isActive" @click="isActive = !isActive">
        <ul>
          <li class="" >
            <router-link  class="navlink" to="/aboutme">About Me</router-link>
          </li>
          <li class="">
            <router-link class="navlink" to="/myprojects">My Projects</router-link>
          </li>
          <li class="">
            <router-link class="navlink contact-button" to="/contactme">Contact Me!</router-link>
          </li>
        </ul>
      </div>
    </transition>
    <main class="grid">
      <router-view class="content"></router-view>
    </main>
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      isActive: false
    };
  },
  methods: {
    toggle: function () {

    }
  }
};
</script>

<style scoped>
#app {
  font-family: 'Ubuntu', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin: 0;
}

.grid {
  margin-top: 10vh;
  display: grid;
  grid-template-columns:
    [full-start] minmax(1em, 1fr)
    [main-start] minmax(0, 40em) [main-end]
    minmax(1em, 1fr) [full-end];
}

.nav-grid {
  display: grid;
  grid-template-columns:
    [full-start] minmax(1em, 1fr)
    [main-start] minmax(0, 80em) [main-end]
    minmax(1em, 1fr) [full-end];
}

.nav-item-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  height: 100%;
}

.flex {
  display: flex;
  justify-content: flex-end;
  align-items: center; 
}

.title {
  justify-content: flex-start;
  margin-left: 50px;
}

.content {
  grid-column: 2/3;
}

ul {
  list-style-type: none;
}

li {
  float: right;
  margin-right: 20px;
}

.navbar {
  background-color: rgba(238, 237, 237, 0.295);
  height: 7.5vh;
  margin: 0;
  position: fixed;
  top: 0;
  z-index: 2;
  width: 100vw;
}

.navbar:hover {
  background-color: rgba(238, 237, 237);
  transition-duration: 500ms;
}

.navbar:hover .navlink {
  color: black;
}

.navlink {
  text-decoration: none;
  color: gray;
  padding-bottom: 10px;
  background-image: linear-gradient(black, black);
  background-size: 0 2px, auto;
  background-repeat: no-repeat;
  background-position: center bottom;
  transition: all 0.3s ease-out;
}

.navlink:hover {
  background-size: 100% 2px, auto;
}

.title-button {
  display: block;
  padding-bottom: 0;
  color: gray;
  background-image: none;
  border: solid 3px gray;
  padding: 2px;
}

.navbar:hover .title-button {
  background-image: none;
  border-color: black;
}

.mobile {
  display: none;
}

.bar1, .bar2, .bar3 {
  z-index: 3;
  width: 35px;
  height: 5px;
  background-color: #333;
  margin: 6px 0;
  transition: 0.4s;
}

.cross .bar1 {
  -webkit-transform: rotate(-45deg) translate(-9px, 6px);
  transform: rotate(-45deg) translate(-9px, 6px);
}

.cross .bar2 {opacity: 0;}

.cross .bar3 {
  -webkit-transform: rotate(45deg) translate(-8px, -8px);
  transform: rotate(45deg) translate(-8px, -8px);
}

.burger-menu {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  position: absolute;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  background-color: rgba(238, 237, 237);
}

.burger-menu li {
  float: none;
  margin: 20px;
}

.burger-menu ul {
  margin-top: 40%;
}

.slide-fade-enter-active {
  transition: all .8s ease;
}
.slide-fade-leave-active {
  transition: all .8s ease;
}
.slide-fade-enter, .slide-fade-leave-to
{
  transform: translateX(100vw);
  opacity: 0;
}

@media screen and (max-width:640px) {
  .grid {
    margin-top: 25%;
  }

  .desktop {
    display: none;
  }

  .navlink {
    font-size: 1.2rem;
  }

  .mobile {
    display: flex;
  }

  .burger {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-end;
    
  }

  .bar1, .bar2, .bar3 {
    margin: 3px;
    background-color: black;
  }

  .title-button {
    display: block;
  }

  .navlink {
    color: black;
    padding-bottom: 0;
    background: none;
  }

  .navbar {
    background-color: rgba(238, 237, 237);
  }

  .title-button {
    border-color: black;
  }

}
</style>



// WEBPACK FOOTER //
// src/App.vue